import url from '@/utils/url';

const basket = url('/kurven');
const simo = url('/abonnementer');
const subscription = url('/abonnementer/:productName');
const configuration = url('/konfiguration');
const checkout = url('/kassen');
const paymentSuccess = url('/kassen/payment/success');
const nemID = url('/nemid');
const mitID = url('/mitid');
const receipt = url('/kvitteringen');
const ceDenied = url('/kreditafvisning/:ceid');
const fatalError = url('/fejl/:step');
const genericError = url('/404');

export {
  simo,
  subscription,
  basket,
  configuration,
  checkout,
  paymentSuccess,
  nemID,
  mitID,
  receipt,
  ceDenied,
  fatalError,
  genericError
};
